import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import VortexBackground from './VortexBackground';
import ClickParticles from './ClickParticles';
import Lichtszene from './licht/Lichtszene';
import FireParticles from './FireParticles';

/**
 * GlobalEffects
 * Renders the site-wide animated Vortex background + click/trail particles
 * on every route, except:
 *   - routes with their own dedicated visual atmosphere (/builder, /aether)
 *   - touch / coarse-pointer devices (mobile / tablet) → no cursor → no trail
 *     + click particles are pure decoration on mobile that costs CPU
 */
// No effects at all (own immersive atmosphere)
const NO_EFFECTS_PATHS = ['/builder'];
// Keep the click particles / cursor trail, but skip the heavy Vortex background
// (the arcade has its own background and the vortex would just waste GPU behind it)
const NO_VORTEX_PATHS = ['/games'];
// Kundenportal: derselbe Lichthintergrund wie die Startseite, fest hinter dem ganzen Bildschirm
const PORTAL_PATHS = ['/aether', '/konto', '/account'];
// Nur hier läuft der Vortex noch (Visitenkarte — alter Look, nirgends verlinkt)
const VORTEX_PATHS = ['/card', '/visitenkarte', '/karte'];

function detectTouchOnly() {
  if (typeof window === 'undefined') return false;
  // Reliable across mobile browsers
  return window.matchMedia('(pointer: coarse), (hover: none)').matches;
}

export default function GlobalEffects() {
  const { pathname } = useLocation();
  const [isTouch, setIsTouch] = useState(detectTouchOnly);

  // Re-evaluate if the user switches input modes (tablet attaching a mouse, etc.)
  useEffect(() => {
    const mq = window.matchMedia('(pointer: coarse), (hover: none)');
    const handler = () => setIsTouch(mq.matches);
    if (mq.addEventListener) mq.addEventListener('change', handler);
    else mq.addListener(handler);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', handler);
      else mq.removeListener(handler);
    };
  }, []);

  const normalized = pathname.replace(/^\/en/, '');
  const matches = (list) => list.some((p) => normalized === p || normalized.startsWith(`${p}/`));

  if (matches(NO_EFFECTS_PATHS)) return null;
  // Alle Seiten im neuen Design (Start, Werkzeuge, Produkte, Kostenlos, Installer, Support,
  // Rechtsseiten, 404) haben einen eigenen, deckenden Hintergrund — der Vortex liefe dort nur
  // unsichtbar mit. Er bleibt deshalb nur auf den Bereichen, die noch den alten Look haben.
  const showVortex = !matches(NO_VORTEX_PATHS) && matches(VORTEX_PATHS);
  const showPortalLicht = matches(PORTAL_PATHS);

  return (
    <>
      {/* Glut-Funken gehören zum alten Look. Auf den neuen Seiten lagen sie unsichtbar hinter dem
          Hintergrund und liefen trotzdem jedes Bild mit (kostete auf dem Handy Leistung) */}
      {showVortex && <><VortexBackground /><FireParticles /></>}
      {showPortalLicht && <div className="portal-licht" aria-hidden="true"><Lichtszene /></div>}
      {!isTouch && <ClickParticles />}
    </>
  );
}
